// extracted by mini-css-extract-plugin
module.exports = {"barStats":"BarStats_barStats__1wOiF"};